import {DebtTypes} from "../../../../../../../../models";
import {Figure} from "../Figure";

export function monthlyOutgoings(mortgage) {

    function loanRepayments(applicant) {
        const applicantN = `applicant${applicant}`;
        const appFirstName = mortgage[applicantN].firstName;
        const uploadSectionsWithFigures = mortgage.uploadSections.filter(it => it.data?.debtType === DebtTypes.LOAN && it.applicant === applicant && !it.data?.clearedBeforeMortgage);

        const fig = new Figure({
            label: `Loan Repayments - ${appFirstName}`,
            disabled: uploadSectionsWithFigures.length === 0,
            namesPath: [ applicantN, 'monthlyOutgoings', 'loans'],
            provable: true,
            float: false,
        })
        let sumLoanPayments = 0;
        uploadSectionsWithFigures.forEach(section => {
            // get the most recent upload for this loan
            const mostRecentUpload = section.verifiableUploads.reduce((latest, current) => {
                return (!latest || (current.values.endDate > latest.values.endDate)) ? current : latest;
            },null)
            if (mostRecentUpload && mostRecentUpload.values.monthlyPayment){
                fig.addMethod({
                    description: section.data.lender + ' Upload',
                    amount: mostRecentUpload.values.monthlyPayment,
                    claimed: section.data?.monthlyPayment,
                    uploadID: mostRecentUpload.id,
                    operator: '+',
                })
                sumLoanPayments += mostRecentUpload.values.monthlyPayment;
            }
            else{
                // if no monthly payment in most recent upload, look for any upload with monthly payment

                const mostRecentUploadWithPayment = section.verifiableUploads.reduce((latest, current) => {
                    if (current.values.monthlyPayment){
                        return (!latest || (current.values.endDate > latest.values.endDate)) ? current : latest;
                    }
                    return latest;
                }, null)
                if (mostRecentUploadWithPayment){
                    fig.addMethod({
                        description: section.data.lender + ' Upload',
                        amount: mostRecentUploadWithPayment.values.monthlyPayment,
                        claimed: section.data?.monthlyPayment,
                        uploadID: mostRecentUploadWithPayment.id,
                        operator: '+',
                        warning: 'Most recent upload is missing monthly payment value'
                    })
                    sumLoanPayments += mostRecentUploadWithPayment.values.monthlyPayment;
                }
                else{
                    fig.addMethod({
                        description: section.data.lender + ' Claimed',
                        amount: section.data?.monthlyPayment,
                        claimed: section.data?.monthlyPayment,
                        uploadID: null,
                        operator: '+',
                        warning: 'No uploads with monthly payment value'
                    })
                    sumLoanPayments += section.data?.monthlyPayment || 0;
                }
            }

        })

        fig.setValue(sumLoanPayments, 'Total loan repayments')
        return fig
    }

    const maintenancePayments = (applicant) => {
        const applicantN = `applicant${applicant}`;
        const appFirstName = mortgage[applicantN].firstName;
        const amount = mortgage[applicantN].financial.paysMaintenance ? mortgage[applicantN].financial.maintenanceCosts : 0;
        // There are no uploads for maintenance payments
        const fig = new Figure({
            label: `Maintenance - ${appFirstName}`,
            disabled:  !mortgage[applicantN].financial.paysMaintenance,
            namesPath: [applicantN,  'monthlyOutgoings', 'maintenance'],
            provable: false,
            float: false,
        })
        fig.setValue(amount, `Claimed maintenance payments`)
        return fig
    }

    const childcareCosts = (applicant) => {
        const applicantN = `applicant${applicant}`;
        const appFirstName = mortgage[applicantN].firstName;
        const amount = mortgage[applicantN].financial.monthlyChildcareCosts || 0;
        // There are no uploads for childcare costs
        const fig = new Figure({
            label: `Childcare Costs - ${appFirstName}`,
            disabled: !mortgage[applicantN].financial.hasChildcareCosts,
            namesPath: [applicantN, 'monthlyOutgoings', 'childcare'],
            provable: false,
            float: false,
        })
        fig.setValue(amount, `Claimed childcare costs`)
        return fig
    }



    const commitments = [];
    commitments.push(loanRepayments(1));
    if (mortgage.twoApplicants){
        commitments.push(loanRepayments(2));
    }
    commitments.push(maintenancePayments(1));
    if (mortgage.twoApplicants){
        commitments.push(maintenancePayments(2));
    }
    commitments.push(childcareCosts(1));
    if (mortgage.twoApplicants){
        commitments.push(childcareCosts(2));
    }
    return commitments.filter(it => it != null);
}